import React from "react";

import editIcon from "images/icons/invite/edit.svg";
import deleteIcon from "images/icons/invite/delete.svg";
import creditsIcon from "images/icons/invite/credits.svg";
import impersonateIcon from "images/icons/invite/impersonate.svg";
import invitationIcon from "images/icons/invite/invitation.svg";

import { useEnterpriseMembersContext } from "../../../../contexts/EnterpriseMembersContext";
import { useInviteMembersContext } from "../../../../contexts/InviteMembersContext";
import Tooltip from "../../../ui/Tooltip";
import routes from "../../../../app/routes";

export default function Actions({ row }) {
  const { dispatch, actions, state } = useEnterpriseMembersContext();
  const { dispatch: inviteDispatch, actions: inviteActions } =
    useInviteMembersContext();

  const inviteMember = (row) => {
    inviteActions.setMembers(inviteDispatch, [row]);
  };

  const deleteMember = (e, row) => {
    swal(
      {
        title: "",
        text: "Are you sure you want to submit a delete request for this member?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Submit",
        cancelButtonText: "Cancel",
        closeOnConfirm: true,
        closeOnCancel: true,
      },
      function (isConfirm) {
        if (isConfirm) {
          let el = e.target;
          while (el && el.tagName !== "A") {
            el = el.parentNode;
          }

          el.innerHTML = '<i class="fa fa-spinner fa-spin"></i>';

          actions.deleteMember(dispatch, row.id);
        }
      }
    );
  };

  const showCredits = (e, row) => {
    actions.showCredits(dispatch, row);
  };

  return (
    <div>
      <a
        data-tip="Show Credits"
        onClick={(e) => showCredits(e, row)}
        className="mr5"
      >
        <img src={creditsIcon} />
      </a>
      <a
        href={routes.api.users.impersonate(row.attributes.user_id)}
        data-tip="Login as User"
        target="_blank"
        className="mr5"
      >
        <img src={impersonateIcon} />
      </a>
      {row.attributes.possible_invite && (
        <a
          onClick={() => inviteMember(row)}
          data-tip="Send Invitation"
          className="mr5"
        >
          <img src={invitationIcon} />
        </a>
      )}
      <a
        href={routes.api.students.edit(row.id)}
        target="_blank"
        data-tip="Edit User's Profile"
        className="mr5"
      >
        <img src={editIcon} />
      </a>

      <a data-tip="Delete User" onClick={(e) => deleteMember(e, row)}>
        <img src={deleteIcon} />
      </a>
      <Tooltip />
    </div>
  );
}
